import { useContext, useEffect, useState } from "react";
import React from "react";
import axios from "axios";
import { BaseUrl, RazorPayKey, RazorPayName, RazorPaySecretKey } from "../../BaseUrl/BaseUrl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import dayjs from "dayjs";
import { handleProceedRemainingPayment } from "../RazorPay/RazorPayFunction";
import { LoaderContext } from "../../AuthContext/AuthContext";
import LazySection from "../../Pages/Home/LazySection";
import DeliveryTracker from "../DeliveryTracker/DeliveryTracker";
import { GetOrderTrackingDetails } from "../../ApiServices/BookingTrack/BookingTrackApi";
const OrderDetails = () => {
  const userID = JSON.parse(localStorage.getItem("userID"));
  const [localData, setLocalData] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [OrderTrackingDetails, setOrderTrackingDetails] = useState(null)
  const { setLoader } = useContext(LoaderContext);
  useEffect(() => {
    axios
      .get(`${BaseUrl}/Estore_order?ORDER_ID=${location?.state?.ORDER_ID} `)
      .then((response) => {
        console.log("Response...", response.data.DATA);
        setOrders(response.data.DATA);
      });
    const storedData = JSON.parse(localStorage.getItem("paymentData"));
    setLocalData(storedData);

    if (location?.state?.ORDER_ID !== null && location?.state?.ORDER_ID !== undefined && location?.state?.ORDER_ID !== '') {
      GetOrderTrackingDetailsData()
    }
  }, []);

  useEffect(() => {
    const calculatedTotal = orders?.reduce(
      (total, order) =>
        total +
        order.RATE * order.QTY -
        Math.round((order.RATE * (order.DISCOUNT * order.QTY)) / 100),
      0
    );
    setTotalAmount(calculatedTotal);
  }, [orders]);

  const handleProceedRemainingEStorePayment = async () => {
    if (localData?.remainingAmount === 0) {
      alert("All the amount already paid");
      return;
    }


    let orderIDReturned = location?.state?.ORDER_ID;
    const finalAmount =
      Number(location?.state?.TOTAL_PRICE) +
      Number(location?.state?.SHIPING_CHARGES);
    console.log("finalAmount", finalAmount);

    const PlaceOrderResponse = await handleProceedRemainingPayment(Math.round(finalAmount))
    console.log('PlaceOrderResponse', PlaceOrderResponse)
    setLoader(true)
    if (PlaceOrderResponse?.status === 1) {
      axios
        .post(`${BaseUrl}/UpdatePaymentStatus?TYPE=Estore`, {
          USER_ID: userID,
          ORDER_ID: orderIDReturned,
          TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
          PAYMENT_STATUS: "Success",
          TRANSACTION_STATUS: "Success",
          TRANSACTION_AMT: finalAmount,
          REMAING_AMOUNT: 0,
          PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
        })
        .then((res) => {
          if (res.data.ResponseMessage === "successfully.") {
            setLoader(false)
            navigate("/my-order");
          } else {
            setLoader(false)
            alert("Order placement failed, please try again.");
          }
        });
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false)
      alert('Order Failed !')
    }
  };

  const handleDownloadInvoice = (ID) => {
    window.open(location?.state?.InvoicePDFURL, "_blank");
    // const pdfUrl = location?.state?.InvoicePDFURL; // Replace with your actual URL
    // const link = document.createElement("a");
    // link.href = pdfUrl;
    // link.download = `Invoice_${ID}.pdf`;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };
  const GetOrderTrackingDetailsData = async () => {
    setLoader(true);
    try {
      let response = await GetOrderTrackingDetails(userID, location?.state?.ORDER_ID, 'Estore'); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);

        const list = response?.DATA || [];
        setOrderTrackingDetails(list[0])

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }
  const stepMap = [
    { key: "BookingDate", label: "Booked" },
    { key: "ConfirmedDate", label: "Confirmed" },
    { key: "ProcessingDate", label: "Processed" },
    { key: "OnTheWayDate", label: "En-Route" },
    { key: "DeliveredDate", label: "Delivered" },
    { key: "CancelledDate", label: "Cancelled" },
    { key: "RejectedDate", label: "Rejected" }
  ];
  return (
    <>
      <div className="m-5 p-5 my-4">
        <div className="row">
          {/* Left Section: Multiple Order Items */}
          <div className="col-md-8">
            {orders.map((order, index) => (
              <div key={index} className="card p-3 mb-3 shadow-sm">
                <div className="d-flex align-items-center">
                  {/* Product Image on the Left */}
                  <img
                    src={order?.PRODUCT_IMG}
                    alt="Product"
                    className="rounded"
                    style={{
                      width: "180px",
                      height: "150px",
                      objectFit: "contain",
                    }}
                  />

                  {/* Product Details in the Center */}
                  <div className="flex-grow-1 px-3">
                    <h6 className="fw-bold">{order?.PRODUCT_NAME}</h6>
                    <p className="text-muted mb-1">
                      Seller: Myomnamo Spiritual Services Pvt Ltd.
                    </p>
                  </div>

                  {/* Price on the Right */}
                  <div className="text-end">
                    <h5 className="fw-bold  mb-0">
                      ₹
                      {order.RATE * order.QTY -
                        Math.round(
                          (order.RATE * (order.DISCOUNT * order.QTY)) / 100
                        )}
                    </h5>
                    {order.DISCOUNT > 0 && (
                      <span className="text-muted small text-decoration-line-through">
                        ₹{order.RATE * order.QTY}
                      </span>
                    )}
                  </div>
                </div>

                {/* Order Status */}

                {/* <hr /> */}
              </div>
            ))}
            {(OrderTrackingDetails !== null && OrderTrackingDetails !== undefined && OrderTrackingDetails !== '') && (

              <div >
                <LazySection><DeliveryTracker statusData={OrderTrackingDetails} stepMap={stepMap} moduleName={'EStore'} /></LazySection>
              </div>
            )}
            {/* <div className="d-flex align-items-center">

              <p className="mb-0">
                Order Confirmed, {location.state.ORDER_DATE}
              </p>
            </div> */}


            {/* <p className="text-muted mt-2">
              Your order will get cancelled if after multiple attempts we
              couldn't able to deliver it.
            </p> */}
          </div>

          {/* Right Section: Single Product's Shipping & Price Details */}
          <div className="col-md-4">
            {/* Shipping Details */}
            <div className="card p-3 mb-3 shadow-sm">
              <h6 className="fw-bold">Shipping details</h6>
              {/* <p className="mb-1 fw-bold">Aniket Kahandal</p> */}
              <p className="text-muted small">
                {location?.state?.ORDER_ADDRESS}
              </p>
              {/* <p className="fw-bold mb-0">Phone number: 9623576236</p> */}
            </div>

            {/* Price Details (Using First Product) */}
            {orders.length > 0 && (
              <div className="card p-3 shadow-sm">
                <h6 className="fw-bold">Price Details</h6>
                <div className="d-flex justify-content-between">
                  <p className=" fw-bold">Product price (₹)</p>
                  <p className="fw-bold">{location?.state?.TOTAL_PRICE}</p>
                </div>
                {Number(location?.state?.TOTAL_DISC) !== 0 && (
                  <div className="d-flex justify-content-between">
                    <p className=" fw-bold">Discount Amount (₹) </p>
                    <p className="fw-bold">{location?.state?.TOTAL_DISC}</p>
                  </div>
                )}

                {location?.state?.CouponCodeAmount !== 0 ? (
                  <div className="d-flex justify-content-between">
                    <p className=" fw-bold">
                      Coupon Amount (₹)
                    </p>
                    <p className=" fw-bold">
                      {location?.state?.CouponCodeAmount}
                    </p>
                  </div>
                ) : location?.state?.WalletAmount !== 0 ?
                  <div className="d-flex justify-content-between">
                    <p className=" fw-bold">
                      Wallet Amount (₹)
                    </p>
                    <p className=" fw-bold" >
                      {location?.state?.WalletAmount}
                    </p>
                  </div> : ''}
                <hr></hr>
                <div className="d-flex justify-content-between">
                  <p className=" fw-bold">Total Amount (₹) </p>
                  <p className="fw-bold">
                    {Number(location?.state?.TOTAL_PRICE) -
                      Number(location?.state?.TOTAL_DISC) - (Number(location?.state?.CouponCodeAmount) === 0 ? Number(location?.state?.WalletAmount) : Number(location?.state?.CouponCodeAmount))}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="fw-bold">
                    Tax ({location?.state?.TaxPercentage}%)
                  </p>
                  <p className=" fw-bold">
                    <span>{location?.state?.TaxAmount}</span>
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="fw-bold">Delivery Charge (₹)</p>
                  <p className=" fw-bold">
                    <span>{location?.state?.DeliveryCharges}</span>
                  </p>
                </div>
                <hr></hr>
                <div className="d-flex justify-content-between">
                  <p className="fw-bold">Grand Total (₹)</p>
                  <p className=" fw-bold">
                    <span> {Number(location?.state?.TRANSACTION_AMT)}</span>
                  </p>
                </div>
              </div>
            )}
            {location?.state?.RemainingAmount == 0 && (
              <button
                className="careox-btn mt-2"
                onClick={() => handleDownloadInvoice(location?.state?.ORDER_ID)}
              >
                Download Invoice
              </button>
            )}
            {/* <button
              className="careox-btn mt-2 mx-2"
              onClick={() => {
                navigate("/view-receipt", {
                  state: {
                    moduleName: "E-store",
                    orderID: location?.state?.ORDER_ID,
                  },
                });

                if (location?.state?.PAYMENT_TYPE == "COD") {
                  navigate("/receipt-details", {
                    state: {
                      moduleName: "Estore",
                      orderID: location?.state?.ORDER_ID,
                    },
                  });
                } else {
                  navigate("/view-receipt", {
                    state: {
                      moduleName: "Estore",
                      orderID: location?.state?.ORDER_ID,
                    },
                  });
                }
              }}
            >
              View Receipt
            </button> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetails;
